import { Place, PlaceJSON, PlaceTypes } from "../models/Place";
import { callDelete, callGet, callPost, } from "./index";
import { AxiosResponse } from "axios";

export class PlaceAPI {
  static async getPlaces(estateId:number): Promise<Place[] | undefined> {
    try {
      const response = await callGet(`estates/${estateId}/places`);
      return response?.data?.map((place: PlaceJSON) => Place.fromJSON(place));
    } catch (error) {
      console.error(error, "getPlaces error");
      throw error;
    }
  }

  static async getPlace(estateId:number, placeId: number): Promise<Place> {
    try {
      const response = await callGet(`estates/${estateId}/places/${placeId}`);
      return Place.fromJSON(response?.data);
    } catch (error) {
      console.error(error, "getPlace error");
      throw error;
    }
  }

  static async savePlace(estateId:number, place: Place): Promise<Place> {
    try {
      let response: AxiosResponse | null;
      if (!place.id) {
        // creating new record
        response = await callPost(`estates/${estateId}/places`, place.toJSON(), true)
      } else {
        // updating existing record
        response = await callPost( `estates/${estateId}/places/${place.id}`, place.toJSON(), true)
      }
      return Place.fromJSON(response?.data);
    } catch (error) {
      console.error(error, "savePlace error");
      throw error;
    }
  }

  static async deletePlace(estateId:number, placeId: number): Promise<boolean> {
    try {
      await callDelete(`estates/${estateId}/places/${placeId}`, true);
      return true; // callDelete will throw error if back-end error
    } catch (error) {
      console.error(error, "deletePlace error");
      throw error;
    }
  }

  static singlePrimaryPlace(places?: Place[]): Place | undefined {
    return places?.find((place: Place) => place.type === PlaceTypes.Primary);
  }
}
